import { render, staticRenderFns } from "./FormCustomer.vue?vue&type=template&id=a2275ee4&scoped=true&"
import script from "./FormCustomer.vue?vue&type=script&lang=js&"
export * from "./FormCustomer.vue?vue&type=script&lang=js&"
import style0 from "./FormCustomer.vue?vue&type=style&index=0&id=a2275ee4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2275ee4",
  null
  
)

export default component.exports